import { LocalDateTime } from '@js-joda/core';

import { convertDateToLocalDateTime } from '@dreryk/react-common';

export const isAutomaticRefundValid = (refundExpirationDate: Date | null | undefined): refundExpirationDate is Date => {
   if (!refundExpirationDate) {
      return false;
   }

   return LocalDateTime.now().isBefore(convertDateToLocalDateTime(refundExpirationDate));
};
